import React from "react";
import PropTypes from "prop-types";
import StoreHeader from "./StoreHeader";
import { DealsContext } from "@Src/routes/deals/Deals.context";

import "./CouponHeader.scss";

function CouponHeader({ isCoupon = false, hideStoreInfo = false, hideStoreDescription = false }) {
  const { store, selectedLocation } = React.useContext(DealsContext);
  const hasBannerImage = () => {
    return !isCoupon && !!selectedLocation.brand_photos?.BANNER?.length;
  };
  const bannerImage = () => {
    return selectedLocation.brand_photos.BANNER[0];
  };
  return (
    <div className={`coupon-header ${isCoupon ? "coupon-header_is-coupon" : ""}`}>
      {hasBannerImage() && (
        <img className="coupon-header_image" src={bannerImage()} alt={selectedLocation.name} />
      )}
      <StoreHeader
        key={store.store_key}
        storeInfo={store}
        location={selectedLocation}
        hideStoreInfo={hideStoreInfo}
        hideStoreDescription={hideStoreDescription}
      />
    </div>
  );
}

CouponHeader.propTypes = {
  isCoupon: PropTypes.bool,
  hideStoreInfo: PropTypes.bool,
  hideStoreDescription: PropTypes.bool,
};

export default CouponHeader;
